import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, KeyValuePair, VariableType, VariableSubType } from '../../models';
import { IStoreService } from '../../services';
import { Unsubscribe } from 'redux';
import { StoreElement, Store } from '../../stateManagement';
import { guidEmpty } from '../../common';
import { getDefaultSubtype } from '../../services/helpers/variable.helper';

class SubtypeSelectContoller implements angular.IComponentController {
    disabled: boolean;
    field: string;
    formController: angular.IFormController;
    model: string;
    properties: KeyValuePair<string, string>[];
    variableTypeGuid: string;

    private _unsubscribe: Unsubscribe;
    private _hasLoaded: angular.IDeferred<void>;
    private _variableTypes: _.Dictionary<VariableType>;
    private _subtypes: _.Dictionary<VariableSubType>;

    static $inject = ['$q', 'storeService'];

    constructor(
        private _$q: angular.IQService,
        private _storeService: IStoreService,
    ) {
        this._hasLoaded = this._$q.defer<void>();
    }

    $onInit() {
        if (!this.field) {
            this.field = 'subTypeProperty';
        }

        this._unsubscribe = this._storeService.register(
            store => this.loadStore(store),
            [StoreElement.Variables]
        );
    }

    $onDestroy() {
        this._unsubscribe();
    }

    $onChanges(changes: angular.IOnChangesObject) {
        if (changes['variableTypeGuid']) {
            if (changes['variableTypeGuid'].currentValue) {
                this._hasLoaded.promise
                    .then(() => {
                        this.properties = this.getSubTypes(this.variableTypeGuid);
                        const updatedValue = getDefaultSubtype(this.model, this.properties);
                        if (updatedValue && updatedValue !== this.model) {
                            this.model = updatedValue;
                        }
                        this.validate();
                    });
            } else {
                this.properties = [];
            }
        }

        if (changes['disabled']) {
            this.validate();
        }
    }

    private getSubTypes(variableTypeGuid: string): KeyValuePair<string, string>[] {
        const vt = this._variableTypes[variableTypeGuid];
        return vt
            ? vt.variableSubTypeGuidCollection
                .map(g => this._subtypes[g])
                .map(st => { return { key: st.guid, value: st.name }; })
            : [];
    }

    change() {
        this.validate();
    }

    private loadStore(store: Store): void {
        this._variableTypes = store.variablesTypes.dictionary;
        this._subtypes = store.variableSubTypes.dictionary;
        this._hasLoaded.resolve();
    }

    private validate() {
        const isValid = !!this.disabled
            || this.properties?.length === 0
            || (!!this.model && this.model !== guidEmpty && _.some(this.properties, p => p.key === this.model));
        this.formController[this.field]?.$setValidity('required', isValid);
    }

}

export const wtSubtypeSelect: ComponentDefinition = {
    componentId: 'wtSubtypeSelect',
    controller: SubtypeSelectContoller,
    template: require('./subtypeSelect.component.html'),
    controllerAs: 'vm',
    bindings: {
        model: '=',
        formController: '<',
        variableTypeGuid: '<',
        field: '@?',
        disabled: '<?'
    }
};